import React from 'react';

const HrCrumb = () => <p>Human Resources</p>;

export default HrCrumb;
